<script setup>
const props = defineProps({
  item: Array,
})

const clock = computed(() => props.item.find(({ item }) => item.type == 'Clock'))

const nonClockItemComponents = computed(() => props.item.filter(({ item }) => item.type != 'Clock'))
</script>

<template>
  <div class="h-full w-full p-safe flex items-start space-x-4">
    <component :is="clock.component" v-if="clock" :key="clock.key" :item="clock.item" />
    <component :is="component" v-for="{ item: currentItem, component, key } in nonClockItemComponents" :key="key" :item="currentItem" />
  </div>
</template>
